import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const mapyReviewInfoOverlayCss = ":host{display:flex;position:fixed;left:0;right:0;top:0;bottom:0;justify-content:center;align-items:center;max-height:100%;overflow:auto;pointer-events:none}.bubble{display:flex;flex-direction:column;padding:50px 24px;background:rgba(0, 0, 0, 0.7);width:296px;max-width:100%;border-radius:16px;gap:12px;align-items:center;font-family:Arial, Helvetica, sans-serif;font-size:22px;font-weight:400;line-height:32px;letter-spacing:0px;text-align:center;color:#ffffff;box-sizing:border-box}";
const MapyReviewInfoOverlayStyle0 = mapyReviewInfoOverlayCss;

const MapyReviewInfoOverlay = /*@__PURE__*/ proxyCustomElement(class MapyReviewInfoOverlay extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.variant = "check";
    }
    render() {
        return (h(Host, { key: '3c3f995088d3bd9293ac16c61c45261b85db6ae4' }, h("div", { key: '28b8f1ae12c20924c16f61a5493e180ebd068eba', class: "bubble" }, this.variant === "check" && h("svg", { key: '5cd75e9938a93991b8277a3157ed5d7b1af01616', width: "56", height: "56", viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '4af299c94901d8f00e01f3551017ae612c26267b', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z", fill: "#1EAE00" }), h("path", { key: '89e8ff9009fb53711fc8435f86db6835612119df', d: "M17.5 28.0002L14 31.5002L23.3333 40.8335L44.3333 19.8335L40.8333 16.3335L23.3333 33.8335L17.5 28.0002Z", fill: "white" })), this.variant === "remove" && h("svg", { key: 'd55483a481f0524908fbfd7a0a54b25a16413f0b', width: "56", height: "56", viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'ba522ee625e53a330ee38734d0094c431d840d19', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M36.166 9.33333H44.3327V14H11.666V9.33333H19.8327L22.166 7H33.8327L36.166 9.33333ZM18.666 49C16.0993 49 13.9993 46.9 13.9993 44.3333V16.3333H41.9993V44.3333C41.9993 46.9 39.8993 49 37.3327 49H18.666Z", fill: "white" })), h("slot", { key: '200652cefecbbcffbb6f15db72e0c2831df87fc2' }))));
    }
    static get style() { return MapyReviewInfoOverlayStyle0; }
}, [1, "mapy-review-info-overlay", {
        "variant": [513]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-info-overlay"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-info-overlay":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewInfoOverlay);
            }
            break;
    } });
}
defineCustomElement();

export { MapyReviewInfoOverlay as M, defineCustomElement as d };

//# sourceMappingURL=mapy-review-info-overlay2.js.map